import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const API_URL = 'http://localhost:5000/api';

const AddMedicine = () => {
  const navigate = useNavigate();
  const [suppliers, setSuppliers] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    stock: '',
    price: '',
    expiryDate: '',
    reorderLevel: 10,
    supplierId: ''
  });

  // Fetch suppliers on component mount
  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        const res = await axios.get(`${API_URL}/suppliers`);
        setSuppliers(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchSuppliers();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_URL}/medicines`, {
        name: formData.name,
        stock: parseInt(formData.stock),
        price: parseFloat(formData.price),
        expiryDate: formData.expiryDate,
        reorderLevel: parseInt(formData.reorderLevel),
        supplierId: formData.supplierId || null
      });
      alert('Medicine added successfully!');
      navigate('/');
    } catch (err) {
      alert('Error adding medicine');
    }
  };

  return (
    <div className="card">
      <h2>➕ Add New Medicine</h2>
      <form onSubmit={handleSubmit} className="medicine-form">
        <input type="text" name="name" placeholder="Medicine name" onChange={handleChange} required />
        <input type="number" name="stock" placeholder="Stock quantity" onChange={handleChange} required />
        <input type="number" step="0.01" name="price" placeholder="Price (₹)" onChange={handleChange} required />
        <input type="date" name="expiryDate" onChange={handleChange} required />
        <input type="number" name="reorderLevel" placeholder="Reorder when stock below" value={formData.reorderLevel} onChange={handleChange} required />
        
        {/* Supplier dropdown */}
        <select name="supplierId" value={formData.supplierId} onChange={handleChange}>
          <option value="">Select Supplier (optional)</option>
          {suppliers.map(sup => (
            <option key={sup._id} value={sup._id}>{sup.name}</option>
          ))}
        </select>
        
        <button type="submit" className="btn-submit">Save Medicine</button>
      </form>
    </div>
  );
};

export default AddMedicine;